<template lang="pug" src="./modal-request-appointment.pug"></template>

<script>
import FormRequest from 'components/form/form-request/form-request'

export default {
  components: {
    FormRequest
  },
  methods: {
    close () {
      this.$store.dispatch('VIEW_SHOWMODAL', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/modal-request-appointment/modal-request-appointment.vue